import { cn } from "@/flokit/utils/styling/cn";
import pluralize from "pluralize";

export const CharacterLimit = ({
  currentLength = 0,
  characterLimit,
  shouldShowValidation = false,
  minimumCharacterLimitToDisplay = 0,
  id,
}: {
  currentLength?: number;
  characterLimit: number;
  minimumCharacterLimitToDisplay?: number;
  shouldShowValidation?: boolean;
  id: string;
}) => {
  const isAboveCharacterLimit = currentLength > (characterLimit ?? Infinity);

  if (currentLength < minimumCharacterLimitToDisplay) {
    return null;
  }

  return (
    <p
      className={cn(
        "self-end font-inter text-sm font-medium",
        isAboveCharacterLimit || shouldShowValidation
          ? "text-ui-red"
          : "text-medium-hippo",
      )}
      id={id}
    >{`(${currentLength}/${characterLimit}) ${pluralize("characters", characterLimit, false)}`}</p>
  );
};
